// extracted by mini-css-extract-plugin
module.exports = {"field":"MetricField-field-3I1GM9","label":"MetricField-label-3-92ZX","value":"MetricField-value-K2RRd2"};